<template>
    <div id="employee" style="height:100%;">
        <el-row>
            <el-col :span="24">
                <el-collapse v-model="activeName" style="margin-bottom:15px;">
                    <el-collapse-item title="操作面板" name="1">
                        <div class="t-op__container">
                            <div class="t-op__item">
                            </div>
                            <div class="t-op__item filter__action">
                                <el-input class="item user" placeholder="请输入员工姓名" v-model="search">
                                </el-input>

                                <el-select class="item project" filterable clearable v-model="projectId"
                                           placeholder="请选择项目">
                                    <el-option
                                            v-for="item in projects"
                                            :key="item.id"
                                            :label="item.projectName"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <el-button icon="el-icon-search" class="search" @click="doSearch"></el-button>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                        row-key="id"
                        v-loading="loading"
                        :data="tableData"
                        width="100%"
                        :height="tableHeight"
                        lazy
                        :load="load"
                        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                        stripe>
                    <!--                    <el-table-column-->
                    <!--                            width="80"-->
                    <!--                            type="index"-->
                    <!--                            label="序号">-->
                    <!--                    </el-table-column>-->
                    <el-table-column
                            min-width="120"
                            label="员工"
                            prop="userId"
                            :formatter="fmtUser">
                    </el-table-column>
                    <el-table-column
                            min-width="100"
                            label="消耗类型"
                            prop="type"
                            :formatter="fmtType">
                    </el-table-column>
                    <el-table-column
                            show-overflow-tooltip
                            min-width="180"
                            label="项目"
                            prop="projectId"
                            :formatter="fmtProjectId">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            label="消耗工时(天)"
                            prop="val">
                    </el-table-column>
                    <el-table-column
                            min-width="120"
                            label="花费成本"
                            prop="cost"
                            :formatter="fmtMoney">
                    </el-table-column>
                    <el-table-column
                            label="状态"
                            prop="status"
                            :formatter="fmtStatus">
                    </el-table-column>
                    <el-table-column
                            width="180"
                            label="提交日期"
                            prop="date"
                            :formatter="fmtJsDate">
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">驳回
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :hide-on-single-page="value"
                        style="padding:10px 0px;"
                        :page-size="pageSize"
                        :total="total"
                        :current-page="pageIndex"
                        @current-change="onCurrentChange">
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "ConsumeManage",
        data() {
            return {
                tableHeight: window.innerHeight * 0.70,
                activeName: [''],
                tableData: [],
                search: '',
                value: false,
                pageIndex: 1,
                pageSize: 20,
                total: 0,
                editItem: {
                    width: '60%',
                    visible: false,
                    title: '员工信息',
                    data: {
                        id: 0,
                        levelId: 0,
                        openId: '',
                        name: '',
                        avatar: '',
                        loginName: '',
                        password: '',
                        status: '',
                        isAdmin: false,
                        addr: '',
                        mobile: '',
                        level: '',
                    },
                    isAdd: false,
                    filter: true,
                    levelList: [],
                    statusList: [{text: "已审核", value: 'confirmed'}
                        , {text: "已驳回", value: 'rejected'}],
                    roleList: [{text: "管理员", value: true}, {text: "普通员工", value: false}],
                    typeList: [{text: "项目消耗", value: "project"}, {text: "个人消耗", value: "self"}],
                    projectList: [],
                    userList: []
                },
                loading: false,
                projects: [],
                projectId: ''
            }
        },
        methods: {
            fmtJsDate(row, column) {
                if (column.property === 'date') {
                    if (!row.date) {
                        return ''
                    } else {
                        return row.date.join('-')
                    }
                }
            },
            fmtUser(row, column) {
                const user = this.editItem.userList.find(v => v.id == row.userId)
                if (user) {
                    return user.name
                }
                return ''
            },
            fmtType(row, column) {
                const type = this.editItem.typeList.find(v => v.value == row.type)
                if (type) {
                    return type.text
                }
                return ''
            },
            fmtProjectId(row, column) {
                const project = this.editItem.projectList.find(v => v.id == row.projectId)
                if (project) {
                    return project.projectName
                }
                return ''
            },
            fmtStatus(row, column) {
                const item = this.editItem.statusList.find(v => v.value == row.status)
                if (item) {
                    return item.text
                }
                return ''
            },
            fmtMoney(row, column) {
                return "￥" + row.cost
            },
            handleEdit(index, row) {
                this.editItem.data = row
                this.$confirm('确认驳回吗?', '提示').then(() => {

                    this.editItem.status = 'invalid'
                    this.confirm()
                }).catch(() => {
                })
            },
            doSearch() {
                this.pageIndex = 1
                this.loadData()
            },
            loadData() {
                this.loading = true
                this.$store.dispatch("employee/getUserConsumeWithPage", {
                    pageSize: this.pageSize,
                    pageNum: this.pageIndex,
                    search: this.search,
                    projectId: this.projectId
                }).then(response => {
                    this.loading = false
                    this.tableData = response.data.data
                    this.total = response.data.total
                })
            },
            onCurrentChange(page) {
                this.pageIndex = page
                this.loadData()
            },
            sexFormat(row, column, cellValue) {
                if (cellValue === 0) {
                    return '女'
                } else {
                    return '男'
                }
            },
            confirm() {
                this.$store.dispatch("employee/saveConsume", this.buildSubmitData())
                    .then(response => {
                        this.$message({
                            message: response.data.message,
                            type: 'success'
                        })
                        this.loadData()
                    })
            },
            buildSubmitData() {
                return {data: this.editItem.data}
            },
            loadAllProjectList() {
                this.$store.dispatch("project/getAllProject")
                    .then(response => {
                        this.editItem.projectList = response.data.data
                    })
            },
            loadUserList() {
                this.$store.dispatch("employee/getAllUsers")
                    .then(response => {
                        if (response && response.data) {
                            this.editItem.userList = response.data.data
                        }
                    });
            },
            loadAllPorject() {
                this.$store.dispatch("project/getAllProject")
                    .then(response => {
                        if (response && response.data) {
                            this.projects = response.data.data
                        }
                    })
            },
            load(tree, treeNode, resolve) {
                this.$store.dispatch('employee/getUserConsumeGroupList', {
                    id: tree.id,
                    userId: tree.userId,
                    date: new Date(tree.date).Format('yyyy-MM-dd')
                }).then(response => {
                    resolve(response.data.data)
                })
            }
        },
        created() {
            this.loadAllProjectList()
            this.loadUserList()
            this.loadAllPorject()
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped lang="scss">
    .t-op__container {
        .filter__action {
            display: flex;
            justify-content: flex-end;
            width: 80%;
            flex-flow: row nowrap;

            .item {
                margin: 10px;

                &.project {
                    width: 200px !important;
                }

                &.user {
                    width: 150px !important;
                }
            }

            .search {
                height: 36px;
                margin: 10px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// consumeManage.vue?10fd888a